
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormDatepicker from "@/components/form/FormDatepickerNew.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import _ from "lodash";
import moment from "moment";
import DOCIcon from "@/components/icons/DOCIcon.vue";
import PDFIcon from "@/components/icons/PDFIcon.vue";
import UploadBoxIcon from "@/components/icons/UploadBoxIcon.vue";
import CarePlanDocument from "@/components/contractors/CarePlanDocument.vue";
import { User } from "@/generated/graphql";

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

@Component({
  components: {
    FormGroup,
    FormInputGroup,
    FormTextarea,
    FormDatepicker,
    UploadBoxIcon,
    CarePlanDocument,
    DOCIcon,
    PDFIcon
  },
})
export default class DocumentationRequirements extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String ,required: true }) readonly clientId!: boolean;

  localFormData: Record<string, any> = {};

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {



    this.localFormData = _.cloneDeep(newVal);


  }

  updateField(field: string, value: any, isDate: boolean = false) {
    if (isDate) {
      this.localFormData[field] = moment(value).toISOString();
    } else {
      this.localFormData[field] = value;
    }
    this.$emit("update:formData", this.localFormData);
  }




}
